export class GlobalConstants {

  public static access = 'access';
  public static granted = 'granted';
  public static MSO = 'MSO';
  public static LCO = 'LCO';
}